<main class="d-flex justify-content-center align-items-center">
  <div class="wrapper d-flex flex-column justify-content-center align-items-center" *ngIf="!isLoading">
    <h2>{{lang === 'en' ? 'Reset Password' : 'إعادة تعيين كلمة المرور'}}</h2>
    <form [formGroup]="resetPasswordForm" class="d-flex flex-column align-items-center p-4">
      <mat-form-field
        color="accent"
        appearance="fill"
        class="authForm"
      >
        <input
          matInput
          required
          formControlName="newPassword"
          id="password"
          type="password"
          placeholder="New Password"
          autocomplete="new-password"
        />
      </mat-form-field>

      <div *ngIf="resetPasswordForm.get('newPassword')?.invalid && resetPasswordForm.get('newPassword')?.touched" class="errorMsgForm">
        {{ getPasswordErrorMessage(resetPasswordForm.get('newPassword')!, 'en') }}
      </div>

      <mat-form-field
        color="accent"
        appearance="fill"
        class="authForm"
      >
        <input
          matInput
          required
          formControlName="confirmPassword"
          id="password"
          type="password"
          placeholder="Confirm Password"
          autocomplete="new-password"
        />
      </mat-form-field>
      <div *ngIf="resetPasswordForm.errors && (resetPasswordForm.get('confirmPassword')?.touched || resetPasswordForm.get('newPassword')?.touched)" class="errorMsgForm">
        {{lang === 'en' ? 'Password does not match.' : '.كلمة السر غير متطابقة'}}
      </div>

      <span class="errorMsg" *ngIf="error">{{"userManagement.resetPassword.error" | translate}}</span>

      <button class="submitBtn" mat-raised-button color="primary" [disabled]="isLoading || resetPasswordForm.invalid" (click)="onReset()">
          <span *ngIf="!isLoading">
            {{lang == 'en' ? 'Reset Password':'إعادة تعيين'}}
          </span>

          <mat-spinner
              *ngIf="isLoading"
              diameter="20"
              color="primary"
          ></mat-spinner>
      </button>
    </form>

  </div>

  <mat-spinner
    color="primary"
    *ngIf="isLoading"
  ></mat-spinner>
</main>
